import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';
import { SharedModule } from 'src/shared/shared.module';

import { CardIconBlockComponent } from 'src/pages/properties/components/shared/card-icon-block/card-icon-block.component';
import { ImpactPillComponent } from 'src/pages/properties/components/shared/impact-pill/impact-pill.component';
import { RoiBarComponent } from 'src/pages/properties/components/shared/roi-bar/roi-bar.component';
import {
  getUpgradeCostLabel,
  getUpgradeIconSrc,
  getUpgradeImpactClass,
  getUpgradeImpactLabel,
  getUpgradeRequestedDaysAgo,
  getUpgradeRoiLabel,
  getUpgradeRoiPercent,
} from 'src/pages/properties/components/shared/upgrade-visuals.util';

import { AddressUpgrade, UPGRADE_STATUS_OPTIONS, UpgradeStatus } from 'src/models/address-upgrade.model';
import { DemoBlockService } from 'src/shared/services/demo-block.service';

@Component({
  selector: 'tidy-upgrade-card',
  templateUrl: './upgrade-card.component.html',
  styleUrls: ['./upgrade-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IonicModule, TidyUiComponentsModule, SharedModule, CardIconBlockComponent, ImpactPillComponent, RoiBarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UpgradeCardComponent {
  @Input() upgrade!: AddressUpgrade;
  @Output() edit = new EventEmitter<AddressUpgrade>();
  @Output() statusChange = new EventEmitter<{ upgrade: AddressUpgrade; status: UpgradeStatus }>();

  private readonly demoBlock = inject(DemoBlockService);

  readonly statusOptions = UPGRADE_STATUS_OPTIONS;

  get impactLabel(): string {
    return getUpgradeImpactLabel(this.upgrade);
  }

  get impactClass(): string {
    return getUpgradeImpactClass(this.upgrade);
  }

  get iconSrc(): string {
    return getUpgradeIconSrc(this.upgrade);
  }

  get costLabel(): string {
    return getUpgradeCostLabel(this.upgrade);
  }

  get roiLabel(): string {
    return getUpgradeRoiLabel(this.upgrade);
  }

  get roiPercent(): number {
    return getUpgradeRoiPercent(this.upgrade);
  }

  get requestedDaysAgo(): string | null {
    return getUpgradeRequestedDaysAgo(this.upgrade);
  }

  onCardClick() {
    if (this.demoBlock.block()) { return; }
    this.edit.emit(this.upgrade);
  }

  onStatusSelect(value: UpgradeStatus) {
    if (this.demoBlock.block()) { return; }
    if (this.upgrade.status === value) {
      return;
    }
    this.statusChange.emit({ upgrade: this.upgrade, status: value });
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
}
